"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Spinner_1 = tslib_1.__importDefault(require("../../../Animations/Spinner/Spinner"));
var Button_1 = require("../Button");
var LoaderButton = function (_a) {
    var loaderShow = _a.loaderShow, loaderColor = _a.loaderColor, loaderSize = _a.loaderSize, children = _a.children, rest = tslib_1.__rest(_a, ["loaderShow", "loaderColor", "loaderSize", "children"]);
    return (React.createElement(StyledButton, tslib_1.__assign({}, rest, { isLoaderButton: true }), loaderShow ? (React.createElement(Spinner_1.default, { color: loaderColor, size: loaderSize, absolute: true })) : (children)));
};
LoaderButton.displayName = 'FOS_LoaderButton';
LoaderButton.defaultProps = {
    loaderColor: '#ffffff',
    loaderSize: 20,
};
var StyledButton = styled_components_1.default(Button_1.Button)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  .button_label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n  }\n"], ["\n  .button_label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n  }\n"])));
exports.default = LoaderButton;
var templateObject_1;
